[
  {
    "code": "EG-DK",
    "name": "Ad Daqahliyah"
  },
  {
    "code": "EG-BA",
    "name": "Al Bahr al Ahmar"
  },
  {
    "code": "EG-BH",
    "name": "Al Buhayrah"
  },
  {
    "code": "EG-FYM",
    "name": "Al Fayyum"
  },
  {
    "code": "EG-GH",
    "name": "Al Gharbiyah"
  },
  {
    "code": "EG-ALX",
    "name": "Al Iskandariyah"
  },
  {
    "code": "EG-IS",
    "name": "Al Isma‘iliyah"
  },
  {
    "code": "EG-GZ",
    "name": "Al Jizah"
  },
  {
    "code": "EG-MNF",
    "name": "Al Minufiyah"
  },
  {
    "code": "EG-MN",
    "name": "Al Minya"
  },
  {
    "code": "EG-C",
    "name": "Al Qahirah"
  },
  {
    "code": "EG-KB",
    "name": "Al Qalyubiyah"
  },
  {
    "code": "EG-LX",
    "name": "Al Uqsur"
  },
  {
    "code": "EG-WAD",
    "name": "Al Wadi al Jadid"
  },
  {
    "code": "EG-SUZ",
    "name": "As Suways"
  },
  {
    "code": "EG-SHR",
    "name": "Ash Sharqiyah"
  },
  {
    "code": "EG-ASN",
    "name": "Aswan"
  },
  {
    "code": "EG-AST",
    "name": "Asyut"
  },
  {
    "code": "EG-BNS",
    "name": "Bani Suwayf"
  },
  {
    "code": "EG-PTS",
    "name": "Bur Sa‘id"
  },
  {
    "code": "EG-DT",
    "name": "Dumyat"
  },
  {
    "code": "EG-JS",
    "name": "Janub Sina'"
  },
  {
    "code": "EG-KFS",
    "name": "Kafr ash Shaykh"
  },
  {
    "code": "EG-MT",
    "name": "Matruh"
  },
  {
    "code": "EG-KN",
    "name": "Qina"
  },
  {
    "code": "EG-SIN",
    "name": "Shamal Sina'"
  },
  {
    "code": "EG-SHG",
    "name": "Suhaj"
  }
]